import React from 'react';
import * as styles from './styles.scss';

const Button = ({ children, className, ...props }) => (
    <button
        className={`${styles.button}${className ? ` ${className}` : ''}`}
        { ...props }
    >
        {children}
    </button>
);

export default Button;
